import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useGetQuizQuery } from "../../../features/quizzes/quizzesApi";
import Quiz from "./Quiz";
import { useSelector } from "react-redux";
import { useCreateQuizMarkMutation } from "../../../features/quizMark/quizMarkApi";

const Quizes = () => {
  const { id } = useParams();
  const { data: quizzes, isLoading, isError, error } = useGetQuizQuery(id);
  const [addQuizMark] = useCreateQuizMarkMutation(); 
  const { user } = useSelector((state) => state.auth);

  const handleSubmitQuiz = (e) => {
    e.preventDefault();
    const selectedOptions = Array.from(
      document.querySelectorAll(`input[type="checkbox"]:checked`)
    );
    const selectedOptionsIds = selectedOptions.map((opt) => {
      const { value } = opt || {};
      return value;
    });

    const totalQuestions = quizzes.length;
    const totalCorrect = selectedOptionsIds.filter(
      (opt) => opt === "true"
    ).length;
    const totalWrong = selectedOptionsIds.filter(
      (opt) => opt === "false"
    ).length;
    const video = quizzes.find((quiz) => quiz.video_id && quiz.video_title);
    // console.log(
    //   "student_id",
    //   user.id,
    //   "student_name",
    //   user.name,
    //   "video_id",
    //   video.video_id,
    //   "video_title",
    //   video.video_title,
    //   "totalQuiz",
    //   totalQuestions,
    //   "totalCorrect",
    //   totalCorrect,
    //   "totalWrong",
    //   totalWrong,
    //   "totalMark",
    //   totalQuestions * 5
    // );
    addQuizMark({
      student_id: user.id,
      student_name: user.name,
      video_id: video.video_id,
      video_title: video.video_title,
      totalQuiz: totalQuestions,
      totalCorrect,
      totalWrong,
      totalMark: totalQuestions * 5,
      mark: totalCorrect * 5,
    });
  };

  const navigate = useNavigate()
  // decide what to do with the data
  let content = null;
  if (isLoading) {
    content = <p>Loading...</p>;
  }
  if (!isLoading && isError) {
    content = <p>{error.message}</p>;
  }
  if (!isLoading && !isError && quizzes.length === 0) {
    navigate("/")
  }
  if (!isLoading && !isError && quizzes.length > 0) {
    const videoTitle = quizzes[0]?.video_title || {};

    content = (
      <>
        <div className="mb-8">
          <h1 className="text-2xl font-bold">{videoTitle}</h1>
          <p className="text-sm text-slate-200">
            Each question contains 5 Mark
          </p>
        </div>
        <div className="space-y-8 ">
          {quizzes.map((quiz) => (
            <Quiz key={quiz.id} quiz={quiz} />
          ))}
        </div>
      </>
    );
  }

  return (
    <form
      onSubmit={handleSubmitQuiz}
      className="mx-auto max-w-7xl px-5 lg:px-0"
    >
      {content}
      <button className="px-4 py-2 rounded-full bg-cyan block ml-auto mt-8 hover:opacity-90 active:opacity-100 active:scale-95 ">
        Submit
      </button>
    </form>
  );
};

export default Quizes;
